import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import styles from "./Header.module.css";
import StoreIcon from "./Images/BSM_Store_Icon.svg";

const Header = ({ onClick, isHome }) => {
  const history = useHistory();

  const handleClick = () => {
    onClick?.();
    history.push("/wwg-store");
  };

  return (
    <div className={styles.header} onClick={handleClick}>
      <img src={StoreIcon} alt="WWG Store Icon" className={styles.header1} />
      <div className={styles.title}>WWG Store</div>
    </div>
  );
};

Header.propTypes = {
  onClick: PropTypes.func.isRequired,
  isHome: PropTypes.bool.isRequired,
};

export default Header;
